angular.module('bmsApp.merrymaids.schedule').factory('MMScheduleCalendarDataSvc', MMScheduleCalendarDataSvc);

MMScheduleCalendarDataSvc.$inject = [
	'$q',
	'CRUDSvc',
];

function MMScheduleCalendarDataSvc(
	$q,
	CRUDSvc
) {
	function dayInfo(params) {
		return CRUDSvc.get('api/merrymaids/schedule/calendar/day-info', params);
	}

	return {
		dayInfo: dayInfo,
	}
}
